import util from '../../libs/util'
import router from '../../router'

export default {
    namespace: true,
    actions: {
        analyticsCharts({commit}, param) {
            util.db.set('charts.info', param['row']).write();
        },

        searchWindow({commit}, param) {
            util.db.set('search.window_id', param).write();
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/chart.js